// extracted by mini-css-extract-plugin
export default {"scrolloverflowtext":"TextOverflow_scrolloverflowtext__O6cD9","floatText":"TextOverflow_floatText__77z73","breaklineoverflowtext":"TextOverflow_breaklineoverflowtext__+nsdS"};